import { render, staticRenderFns } from "./prize-competition-error.vue?vue&type=template&id=aa747242&scoped=true&lang=pug"
import script from "./prize-competition-error.vue?vue&type=script&setup=true&lang=js"
export * from "./prize-competition-error.vue?vue&type=script&setup=true&lang=js"
import style0 from "./prize-competition-error.vue?vue&type=style&index=0&id=aa747242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa747242",
  null
  
)

export default component.exports